import {Grid} from "@mui/material"
import React, {useContext} from "react"
import Field from "../../Field"
import charLimit from "../../../lib/charLimit";
import {OrgCustomizationContext} from "../../../themes/OrgCustomizationProvider";
import CountrySelectInput from "../../Inputs/CountrySelectInput";

type ShippingInfoFormProps = {
    formik: any // Formik doesn't have a type for this...
}

const ShippingInfoForm: React.FC<ShippingInfoFormProps> = ({formik}) => {
    const {t} = useContext(OrgCustomizationContext)

    return (
        <>
            <Grid
                container
                xs={12}
                sm={12}
                md={9}
                lg={6}
                xl={6}
                sx={{
                    backgroundColor: 'rgba(0,0,0,.05)',
                }}
                justifyContent='center'
                alignSelf='start'
            >

                <Grid item xs={9} sm={9} md={9} lg={9} sx={{marginRight: '2rem'}}>
                    <Field
                        id="street"
                        name="street"
                        label={t('gi_street_house_no') + '*'}//"Street, house no." 
                        variant="outlined"
                        value={formik.values.street}
                        error={
                            formik.touched.street
                            &&
                            Boolean(formik.errors.street)
                        }
                        helperText={
                            formik.touched.street
                            &&
                            formik.errors.street
                        }
                        onChange={(e) => {

                            let string = e.currentTarget.value

                            const max = 60

                            const result = charLimit({string, max})

                            formik.setFieldValue('street', result, true)

                        }}/>
                    <Field
                        id="city"
                        label={t('gi_city') + '*'}//"City"
                        name="city"
                        variant="outlined"
                        value={formik.values.city}
                        error={
                            formik.touched.city
                            &&
                            Boolean(formik.errors.city)
                        }
                        helperText={
                            formik.touched.city
                            &&
                            formik.errors.city
                        }
                        onChange={(e) => {

                            let string = e.currentTarget.value

                            const max = 40

                            const result = charLimit({string, max})

                            formik.setFieldValue('city', result, true)

                        }}/>
                    <Field
                        id="region"
                        label={t('gi_region')}//"State"
                        name="region"
                        variant="outlined"
                        value={formik.values.region}
                        error={
                            formik.touched.region
                            &&
                            Boolean(formik.errors.region)
                        }
                        helperText={
                            formik.touched.region
                            &&
                            formik.errors.region
                        }
                        onChange={(e) => {

                            let string = e.currentTarget.value

                            const max = 20

                            const result = charLimit({string, max})

                            formik.setFieldValue('region', result, true)

                        }}/>
                    <Field
                        id="postalCode"
                        label={t('gi_postal_code')}//"Postal Code" 
                        name="postalCode"
                        variant="outlined"
                        value={formik.values.postalCode}
                        error={
                            formik.touched.postalCode
                            &&
                            Boolean(formik.errors.postalCode)
                        }
                        helperText={
                            formik.touched.postalCode
                            &&
                            formik.errors.postalCode
                        }
                        onChange={(e) => {

                            let string = e.currentTarget.value

                            const max = 10

                            const result = charLimit({string, max})

                            formik.setFieldValue('postalCode', result, true)

                        }}/>

                    <CountrySelectInput name='country'
                                        label={t('gi_country') + '*'}
                                        value={formik.values.country}
                                        onChange={formik.handleChange}
                                        error={formik.touched.country && !!formik.errors.country}
                                        helperText={formik.touched.country && `${t('')}`}/>
                </Grid>
            </Grid>
        </>
    )
}

export default ShippingInfoForm
